<template>
    <div>
        <div class="container">
            <document-tab @toggle="toggleTab"></document-tab>

            <document-tab-content
                :physician="{
                    ViewTab: isViewTabActive,
                    UploadTabs: isUploadTabActive,
                    RequestTab: isRequestTabActive,
                }"
                @toggle="toggleTab"
            ></document-tab-content>
        </div>
    </div>
</template>

<script>
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import DocumentTab from 'components/forms/patient/DocumentTabs'
    import DocumentTabContent from 'components/forms/patient/DocumentTabContent'
    const TabEnum = Object.freeze({
        VIEW: 'view',
        UPLOAD: 'upload',
        REQUEST: 'request',
    })
    export default {
        mixins: [PageWithDataMixin, FormMixin, HandleRequestMixin],
        components: {
            DocumentTab,
            DocumentTabContent,
        },
        data() {
            return {
                TabEnum,
                isViewTabActive: true,
                isUploadTabActive: false,
                isRequestTabActive: false,
            }
        },

        methods: {
            toggleTab(name) {
                this.isViewTabActive = false
                this.isUploadTabActive = false
                this.isRequestTabActive = false
                switch (name) {
                    case TabEnum.VIEW:
                        this.isViewTabActive = true
                        break
                    case TabEnum.UPLOAD:
                        this.isUploadTabActive = true
                        break
                    case TabEnum.REQUEST:
                        this.isRequestTabActive = true
                        break
                }
            },
        },
    }
</script>
